'use strict';

export let ArticuloListComponent = {
    selector: 'articuloList',
    template: require('./articulo-list.html'),
    transclude: true,
    scope: true,
    bindings: {
        columna: '@',
        articulos: '<'
    }
};



// WEBPACK FOOTER //
// ./client/components/articulo/articulo-list/articulo-list.component.js